<template>
  <div>
    <div class="breadcrumb-area pos-relative w-100">
      <h1 class="title_mo">Quản lý Khách Hàng ( MO )</h1>
      <div class="float-right btn-group">
        <DraggableTable
          :naming="$route.name"
          v-model="fields"
          @change="filterTable = $event"
        />
      </div>
    </div>
    <div class="card p-10 pt-15">
      <div class="card-header m-b-10">
        <form class="box-search search_css" @submit="submitForm">
          <div class="form-group">
            <input
              type="text"
              v-model.trim="filters.textSearch"
              class="form-control f12 hc-37 text-search"
              placeholder="Từ khóa"
            />
          </div>
          <div class="form-group">
            <input
              type="text"
              v-model.trim="filters.masterName"
              class="form-control f12 hc-37 text-search"
              placeholder="Tên thương hiệu"
            />
          </div>
          <div class="form-group">
            <Select2
              v-model="filters.businessRegionCode"
              :options="dataConfigRegion"
              @change="queryProvince($event)"
              placeholder="Vùng kinh doanh"
            />
          </div>
          <div class="form-group">
            <Select2
              v-model="filters.businessProvinceCode"
              :options="dataProvince"
              :disabled="
                !filters.businessRegionCode ||
                filters.businessRegionCode === '0'
              "
              placeholder="Tỉnh/Thành phố kinh doanh"
            />
          </div>
          <div class="form-group">
            <Select2
              v-model="filters.managerStaffId"
              :options="listUser"
              placeholder="Quản lý"
            />
          </div>
          <div class="form-group">
            <Select2
              v-model="filters.staffId"
              :options="listUser"
              placeholder="Nhân viên chăm sóc"
            />
          </div>
          <!-- <div class="form-group">
            <Select2 v-model="filters.typeAssign"
              :options="[{ id: 'MAIN', text: 'Chính' }, { id: 'SECOND', text: 'Phụ' }]" placeholder="Trạng thái gán" />
          </div> -->
          <div class="form-group">
            <Select2
              v-model="filters.regionCode"
              :options="dataConfigRegionMC"
              @change="queryMcProvince($event)"
              placeholder="Vùng merchant"
            />
          </div>
          <div class="form-group">
            <Select2
              v-model="filters.provinceCode"
              :options="dataProvinceMC"
              placeholder="Tỉnh/Thành phố merchant"
              :disabled="!filters.regionCode || filters.regionCode === '0'"
              @change="getMcDistrict($event)"
            />
          </div>
          <div class="form-group">
            <Select2
              v-model="filters.districtCode"
              :options="dataDistrict"
              placeholder="Quận/Huyện merchant"
              :disabled="!filters.provinceCode || filters.provinceCode === '0'"
            />
          </div>
          <div class="form-group">
            <Select2
              v-model="filters.mcLvl"
              :options="listMcType"
              placeholder="Cấp bậc merchant"
            />
          </div>
          <div class="form-group">
            <Select2
              v-model="filters.mainBusinessMcc"
              :options="dataConfigMcc"
              placeholder="Ngành nghề"
            />
          </div>
          <div class="form-group">
            <Select2
              v-model="filters.ownershipType"
              :options="ownershipType"
              placeholder="Loại hình sở hữu"
            />
          </div>
          <!-- <div class="form-group">
            <Select2 v-model="filters.assignState"
              :options="[{ id: 0, text: 'Tất cả' }, { id: 1, text: 'Đã gán' }, { id: 2, text: 'Chưa gán' }]"
              placeholder="Tình trạng gán NVCS" />
          </div> -->
          <div class="form-group">
            <Select2
              v-model="filters.status"
              :options="listStatus"
              placeholder="Trạng thái hoạt động"
            />
          </div>
          <!-- <div class="form-group">
            <Select2 v-model="filters.authStatus" :options="listAuthStatus" placeholder="Trạng thái xác thực" />
          </div> -->
          <div class="form-group form-group-action search_css">
            <button
              @click="submitForm"
              class="btn btn-primary hc-37 mr-2 pt-2"
              data-toggle="tooltip"
              data-placement="top"
              title="Lọc"
            >
              <i class="bx bx-filter-alt"></i>
              <span>&nbsp;</span>Lọc
            </button>

            <button
              type="button"
              @click="clearSearch"
              class="btn btn-outline-light hc-37 mr-2 pt-2"
              data-toggle="tooltip"
              data-placement="top"
              title="Bỏ lọc"
            >
              <i class="bx bx-filter-alt"></i>
              <span>&nbsp;</span>Bỏ lọc
            </button>
            <!-- <button type="button" @click="onAssignHandle" class="btn btn-outline-info hc-37 mr-2 pt-2"
              data-toggle="tooltip" data-placement="top" title="Gán nhân viên" :disabled="!(checkedItems.length > 0)">
              <span>&nbsp;</span>Gán nhân viên
            </button> -->
          </div>
        </form>
      </div>
      <div class="card-body">
        <div class="tab-content" id="nav-tabContent">
          <div class="p-10">
            <div class="d-flex flex-row">
              <div class="box-header list_total">
                <TotalCount :totals="totalCount" :data="totals"></TotalCount>
                <!-- Tổng số tài khoản: <strong class="text-primary">{{ totals.suspend + totals.active }}</strong>
                &nbsp;&nbsp;| &nbsp;&nbsp;
                Đang hoạt động: <strong class="text-success">{{ totals.active }}</strong> &nbsp;&nbsp;| &nbsp;&nbsp;
                Bị khóa: <strong class="text-danger">{{ totals.suspend }}</strong> -->
              </div>
              <div
                v-show="idsSelected.length"
                @click="onClearSelect"
                class="text-nowrap ml-auto text-primary cursor-pointer clean-select"
                v-b-tooltip.hover
                :title="`Click để bỏ chọn, chọn tối đa ${maxtSelect}`"
              >
                Đã chọn:
                <strong class="text-danger">{{
                  idsSelected.length.toLocaleString('vi-VN')
                }}</strong>
              </div>
            </div>
            <b-table
              bordered
              hover
              head-variant="light"
              fixed
              show-empty
              responsive
              sticky-header
              :items="dataTable"
              :fields="filterTable"
              :busy.sync="isLoading"
            >
              <template #table-busy>
                <div class="text-center my-2">
                  <b-spinner class="align-middle" />
                </div>
              </template>
              <template #empty>
                <div class="text-center text-info my-2">Không có dữ liệu</div>
              </template>
              <template #emptyfiltered="{ emptyFilteredText }">
                <h4>{{ emptyFilteredText }}</h4>
              </template>

              <template #cell(mobile)="{ value }">
                {{ value | encryptPhone }}
              </template>

              <!-- <template #head(checkbox)>
                <b-form-checkbox v-model="selectAll" @change="toggleSelectAll" :disabled="isLoading" />
              </template>
              <template #cell(checkbox)="{ item }">
                <b-form-checkbox v-model="item.checked" @change="toggleSelectOne(item)" />
              </template> -->

              <template #cell(index)="{ index }">
                {{
                  pagination.page > 1
                    ? index + 1 + pagination.limit * (pagination.page - 1)
                    : index + 1
                }}
              </template>

              <template #cell(ownerName)="{ value }">
                {{ value }}
              </template>

              <template #cell(logo)="{ value }">
                <img :src="value" width="48" height="48" />
              </template>

              <template #cell(owner)="{ item }">
                <div class="d-flex align-items-center">
                  <b-icon icon="person-fill" class="mr-2"></b-icon>
                  <span
                    ><b-link
                      :href="`/customer-support/merchant-owner/${item.id}`"
                      style="color: #0056f6"
                      target="_blank"
                      >{{ item.ownerName || '' }}</b-link
                    ></span
                  >
                </div>
                <div class="d-flex align-items-center">
                  <b-icon icon="shop" class="mr-2"></b-icon>
                  <span>{{ item.masterName || '' }}</span>
                </div>
                <div style="padding-left: 20px">
                  <a :href="`mailto:${item.email}`">{{ item.email }}</a>
                </div>
                <div style="padding-left: 20px">
                  <strong><span style="color: darkred">DKKD</span>:</strong>
                  {{ item.businessRegistrationNumber }}
                </div>
              </template>

              <template #cell(address)="{ item }">
                <p>
                  <span class="text-muted">Vùng:</span>
                  {{ item.regionName ?? '' }}
                </p>
                <p>
                  <span class="text-muted">Tỉnh:</span>
                  {{ item.provinceName ?? '' }}
                </p>
                <p>
                  <span class="text-muted">Quận/huyện:</span>
                  {{ item.districtName ?? '' }}
                </p>
                <p>
                  <span class="text-muted">Địa chỉ:</span>
                  {{ item.headquartersAddress ?? '' }}
                </p>
              </template>

              <!-- <template #cell(summary)="{ item }">
                <p>DV ký HĐ: </p>
                <p>Tài khoản:</p>
                <p>Cửa hàng: </p>
                <p>Thiết bị: </p>
              </template> -->

              <template #cell(contractStatus)="{ item }">
                <div
                  class="text-center"
                  v-if="item.mcStatus || item.mcStatus != 'null'"
                >
                  <b-badge :variant="`${getStatusClass(item.mcStatus)}`">{{
                    getStatusName(item.mcStatus)
                  }}</b-badge>
                </div>
              </template>

              <template #cell(confirmStatus)="{ item }">
                <div class="text-center" v-if="item.authStatus">
                  <b-badge
                    :variant="`${getAuthStatusClass(item.authStatus)}`"
                    >{{ getAuthStatusName(item.authStatus) }}</b-badge
                  >
                </div>
              </template>

              <template #cell(source)="{ item }">
                <p>{{ item.saleStaffName }}</p>
                <b-badge
                  pill
                  variant="light"
                  style="border: 1px solid #13569f; color: #13569f"
                  >{{ item.referSource }}</b-badge
                >
              </template>

              <template #cell(sync)="{ item }">
                <div>
                  <b-icon
                    icon="arrow-repeat"
                    class="mr-2"
                    style="width: 16px; height: 16px"
                  ></b-icon>
                  {{ item.lastSyncTime | formatDate('HH:mm') }},
                  {{ item.lastSyncTime | formatDate }}
                </div>
                <!-- <div class="text-center">
                  <b-badge pill variant="light" style="border: 1px solid #13569F; color: #13569F; min-width: 70px;">{{
                    item.referSource
                    }}</b-badge>
                </div> -->
              </template>

              <template #cell(businessType)="{ item }">
                <p>
                  <span
                    @click="searchBusinessType(item)"
                    style="cursor: pointer"
                    >{{ getBusinessTypeName(item.mainBusinessMcc) }}</span
                  >
                </p>
                <p class="text-primary">
                  <span
                    @click="searchOwnershipType(item)"
                    style="cursor: pointer"
                    >{{ getOwnershipTypeNAme(item.ownershipType) }}</span
                  >
                </p>
              </template>

              <template #head(actions)="{ label }">
                <div>{{ label }}</div>
              </template>

              <template #cell(actions)="{ item }">
                <div class="text-center">
                  <b-link
                    :href="`/customer-support/merchant-owner/${item.id}`"
                    style="color: #0056f6"
                    size="sm"
                    target="_blank"
                  >
                    <img
                      src="@/assets/img/circle-three-dots.svg"
                      alt="Circle with Three Dots"
                      style="width: 15px; height: 15px"
                    />
                    Chi tiết
                  </b-link>
                </div>
              </template>
            </b-table>
            <div class="d-flex justify-content-end">
              <b-form-group class="mb-0" style="padding: 17px">
                <b-form-select
                  v-model="pagination.limit"
                  :options="pageOptions"
                  @change="onItemsPerPageChange"
                ></b-form-select>
              </b-form-group>
              <b-pagination
                v-model="pagination.page"
                :total-rows="totalCount"
                :per-page="pagination.limit"
                @change="onChangePage"
              />
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { mapGetters } from 'vuex'
import { StaffService } from '@/services/staff.service'
import Config from '@/thirdParty/config'
import { CommonService } from '@/services/common.service'
import { SalesManagerService } from '@/services/sales-manager.service'
import { List, GetCount } from '@/services/customer-support/merchant-owner'
import { showMess } from '@/config/utils'
import moment from 'moment'
import { level3LocationDetails } from '@/config/manhthdConfigs'
import TotalCount from '@/components/cskh/Counts.vue'
import gzip from 'gzip-js'

const maxtSelect = 200

export default {
  components: {
    TotalCount
  },
  data() {
    return {
      filters: {
        textSearch: '',
        mcLvl: '',
        regionCode: '',
        provinceCode: '',
        districtCode: '',
        businessRegionCode: '',
        businessProvinceCode: '',
        managerStaffId: '',
        staffId: '',
        typeAssign: '',
        mainBusinessMcc: '',
        ownershipType: '',
        assignState: 0,
        status: ''
      },
      isLoading: true,
      selectAll: false,
      checkedItems: [],
      dataConfigRegion: [],
      dataProvince: [],
      dataConfigRegionMC: [],
      dataProvinceMC: [],
      dataDistrict: [],
      dataConfigMcc: [],
      dataManager: [],
      listUser: [],
      listStateSearch: [],
      userId: JSON.parse(localStorage.getItem('userData')).userId,
      totalCount: 0,
      // config
      dataConfigService: [],
      sourceCreate: Config.sourceCreate,
      localeData: Config.localeData,
      ownershipType: [], // systemConfig.ownershipType,

      listMcType: [
        { id: 0, text: 'Tất cả' },
        { id: 'MC_KEY', text: 'Merchant key' },
        { id: 'MC_NORMAL', text: 'Merchant thường' }
      ],
      listStatus: [
        { id: 0, text: 'Tất cả' },
        {
          id: 'ACTIVE',
          text: 'Đang hoạt động',
          bgColor: 'primary',
          class: 'text-success'
        },
        {
          id: 'PENDING_CONFIRM_APPROVAL',
          text: 'Chờ duyệt',
          bgColor: 'danger',
          class: 'text-danger'
        },
        {
          id: 'SUSPENDED',
          text: 'Bị khoá',
          bgColor: 'danger',
          class: 'text-danger'
        },
        {
          id: 'UNDEFINED',
          text: 'Không xác định',
          bgColor: 'secondary',
          class: 'text-secondary'
        }
      ],
      listAuthStatus: [
        { id: 'NOT_AUTHENTICATED', text: 'Chưa xác thực', bgColor: 'warning' },
        { id: 'AUTHENTICATED', text: 'Đã xác thực', bgColor: 'success' }
      ],
      fields: [
        {
          key: 'index',
          label: 'STT',
          class: 'text-center'
        },
        {
          key: 'logo',
          label: 'Logo',
          sortable: false,
          class: 'text-center'
        },
        {
          key: 'owner',
          label: 'ĐVCNT',
          sortable: false,
          thStyle: 'min-width: 100px',
          tdClass: 'owner_class'
        },
        {
          key: 'address',
          label: 'Địa chỉ',
          sortable: false,
          thStyle: 'min-width: 100px',
          tdClass: 'address_class'
        },
        {
          key: 'businessType',
          label: 'Ngành nghề/Loại SH',
          sortable: false,
          thStyle: 'min-width: 100px',
          tdClass: 'business_type_class'
        },

        {
          key: 'contractStatus',
          label: 'Trạng thái hoạt động',
          sortable: false,
          thStyle: 'min-width: 100px; max-width: 150px;',
          class: 'text-center status_class'
        },
        {
          key: 'sync',
          label: 'Ngày đồng bộ',
          sortable: false,
          thStyle: 'min-width: 150px'
        },
        {
          key: 'actions',
          label: 'Thao tác',
          sortable: false,
          class: 'text-center',
          thStyle: 'min-width: 80px'
        }
      ],
      pagination: {
        queryString: '',
        sortField: 'createdDate',
        sortType: 'DESC',
        page: 1,
        total: 0,
        limit: 20
      },
      totals: {
        suspend: 0,
        active: 0
      },
      dataTable: [],
      dateRange: {
        startDate: null,
        endDate: null
      },
      pageOptions: [
        { value: 20, text: '20/trang' },
        { value: 50, text: '50/trang' },
        { value: 100, text: '100/trang' },
        { value: 200, text: '200/trang' }
      ],
      filterTable: this.fields,

      // multiple select row
      idsSelected: [],
      maxtSelect
    }
  },
  filters: {
    transfromRegion(data, dataConfigRegion) {
      const dataReturn = dataConfigRegion.filter((e) => e.id === data)
      if (dataReturn.length === 0) {
        return ''
      }
      return dataReturn[0].text
    }
  },
  async mounted() {
    await this.configSystem()
    if (this.dataPermission.includes('CNPS_CSS_MO_LIST')) {
      await this.getRegions()
      // await this.getManager()
      await this.getListStaffBySuperior()
      // await this.buildQuery()
      await this.buildQueryV2()
      await this.getMcRegions()
      // await this.getMcDistrict()
    } else {
      this.$bvModal
        .msgBoxOk('Bạn không có quyền truy cập vào trang này', {
          title: 'Cảnh báo',
          okVariant: 'danger',
          headerClass: 'p-2 border-bottom-0',
          footerClass: 'p-2 border-top-0',
          centered: true
        })
        .then(() => {
          this.$router.replace('/')
        })
    }
  },
  computed: {
    ...mapGetters({
      dataPermission: 'role/dataPermission'
    }),
    getStatusName() {
      return (status) => {
        const objStatus = this.listStatus.find((s) => s.id === status)
        return objStatus ? objStatus.text : status
      }
    },
    getStatusClass() {
      return (status) => {
        const objStatus = this.listStatus.find((s) => s.id === status)
        return objStatus ? objStatus.bgColor : 'badge-primary'
      }
    },

    getAuthStatusName() {
      return (status) => {
        const objStatus = this.listAuthStatus.find((s) => s.id === status)
        return objStatus ? objStatus.text : status
      }
    },
    getAuthStatusClass() {
      return (status) => {
        const objStatus = this.listAuthStatus.find((s) => s.id === status)
        return objStatus ? objStatus.bgColor : 'badge-primary'
      }
    },
    getBusinessTypeName() {
      return (mcc) => {
        const objStatus = this.dataConfigMcc.find((s) => s.id === mcc)
        return objStatus ? objStatus.text : mcc
      }
    },
    getOwnershipTypeNAme() {
      return (ownertShipType) => {
        const objStatus = this.ownershipType.find(
          (s) => s.id === ownertShipType
        )
        return objStatus ? objStatus.text : ownertShipType
      }
    },
    hasCheckeds() {
      // return this.dataTable.some(row => row.checked)
      return this.idsSelected.length > 0
    }
  },
  methods: {
    onItemsPerPageChange() {
      this.pagination.page = 1 // Reset về trang 1 khi thay đổi số mục mỗi trang
      this.refreshTable()
    },
    refreshTable() {
      // this.buildQuery();
      this.buildQueryV2()
    },
    // nút bỏ lọc
    async clearSearch() {
      this.pagination.page = 1
      this.filters.textSearch = ''
      this.filters.mcLvl = ''
      this.filters.regionCode = ''
      this.filters.provinceCode = ''
      this.filters.districtCode = ''
      this.filters.businessRegionCode = ''
      this.filters.businessProvinceCode = ''
      this.filters.managerStaffId = ''
      this.filters.staffId = ''
      this.filters.typeAssign = ''
      this.filters.mainBusinessMcc = ''
      this.filters.ownershipType = ''
      this.filters.assignState = 0
      this.filters.status = ''
      this.dataProvince = []
      this.dataProvinceMC = []
      this.dataDistrict = []
      // await this.buildQuery()
      await this.buildQueryV2()
    },
    async buildQuery() {
      const conditions = []
      const conditionsMap = {}

      const textSearch = this.filters.textSearch?.trim()
      textSearch && conditions.push(`{textSearch} LIKE '''${textSearch}'''`)

      this.filters.mcLvl &&
        this.filters.mcLvl !== '0' &&
        conditions.push(`{mcLvl} == '''${this.filters.mcLvl}'''`)

      this.filters.businessRegionCode &&
        this.filters.businessRegionCode !== '0' &&
        (conditionsMap.businessRegionCode = this.filters.businessRegionCode)
      this.filters.businessProvinceCode &&
        this.filters.businessProvinceCode !== '0' &&
        (conditionsMap.businessProvinceCode = this.filters.businessProvinceCode)

      this.filters.managerStaffId &&
        this.filters.managerStaffId !== '0' &&
        (conditionsMap.managerStaffId = this.filters.managerStaffId)
      this.filters.mainBusinessMcc &&
        this.filters.mainBusinessMcc !== '0' &&
        conditions.push(
          `{mainBusinessMcc} == '''${this.filters.mainBusinessMcc}'''`
        )
      this.filters.ownershipType &&
        this.filters.ownershipType !== '0' &&
        conditions.push(
          `{ownershipType} == '''${this.filters.ownershipType}'''`
        )
      // this.filters.assignState && (conditionsMap.assignState = this.filters.assignState)
      this.filters.status &&
        this.filters.status !== '0' &&
        conditions.push(`{mcStatus} == '''${this.filters.status}'''`)

      this.filters.regionCode &&
        this.filters.regionCode !== '0' &&
        conditions.push(`{regionCode} == '''${this.filters.regionCode}'''`)
      this.filters.provinceCode &&
        this.filters.provinceCode !== '0' &&
        conditions.push(`{provinceCode} == '''${this.filters.provinceCode}'''`)
      this.filters.districtCode &&
        this.filters.districtCode !== '0' &&
        conditions.push(`{districtCode} == '''${this.filters.districtCode}'''`)

      if (this.filters.staffId && this.filters.staffId !== '0') {
        conditionsMap.staffId = this.filters.staffId
        // this.filters.typeAssign && (conditionsMap.typeAssign = this.filters.typeAssign)
      }

      this.pagination.queryString = conditions.join(' AND ')
      // await this.loadData(conditionsMap);
      // await this.getCount(conditionsMap);
      await this.getData(conditionsMap)
    },
    async buildQueryV2() {
      const conditionsMap = {}

      const region = this.dataConfigRegionMC.find(
        (s) => s.id === this.filters.regionCode
      )

      this.filters.textSearch &&
        this.filters.textSearch?.trim() &&
        (conditionsMap.keyWord = this.filters.textSearch)

      this.filters.mcLvl &&
        this.filters.mcLvl !== '0' &&
        (conditionsMap.mcLvl = this.filters.mcLvl)
      this.filters.businessRegionCode &&
        this.filters.businessRegionCode !== '0' &&
        (conditionsMap.businessRegionId = this.filters.businessRegionCode)
      this.filters.businessProvinceCode &&
        this.filters.businessProvinceCode !== '0' &&
        (conditionsMap.businessProvinceId = this.filters.businessProvinceCode)
      this.filters.mainBusinessMcc &&
        this.filters.mainBusinessMcc !== '0' &&
        (conditionsMap.mainBusinessMcc = this.filters.mainBusinessMcc)
      this.filters.ownershipType &&
        this.filters.ownershipType !== '0' &&
        (conditionsMap.ownershipType = this.filters.ownershipType)
      this.filters.status &&
        this.filters.status !== '0' &&
        (conditionsMap.mcStatus = this.filters.status)
      this.filters.regionCode &&
        this.filters.regionCode !== '0' &&
        region &&
        (conditionsMap.regionCode = region.code)
      this.filters.provinceCode &&
        this.filters.provinceCode !== '0' &&
        (conditionsMap.provinceCode = this.filters.provinceCode)
      this.filters.districtCode &&
        this.filters.districtCode !== '0' &&
        (conditionsMap.districtCode = this.filters.districtCode)
      this.filters.managerStaffId &&
        this.filters.managerStaffId !== '0' &&
        (conditionsMap.managerStaffId = this.filters.managerStaffId)
      this.filters.staffId &&
        this.filters.staffId !== '0' &&
        (conditionsMap.staffId = this.filters.staffId)

      const textmasterName = this.filters.masterName?.trim()

      if (textmasterName) {
        conditionsMap.masterName = textmasterName
      }

      await this.getDataV2(conditionsMap)
    },
    async getData(conditionsMap = {}) {
      const searchQuery = {
        limit: this.pagination.limit,
        page: this.pagination.page,
        queryString: this.pagination.queryString,
        ...conditionsMap,
        sort: {
          direction: this.pagination.sortType,
          properties: [this.pagination.sortField]
        }
      }
      try {
        this.isLoading = true
        const [resList, resCount] = await Promise.all([
          List(searchQuery),
          GetCount({
            queryString: this.pagination.queryString,
            ...conditionsMap
          })
        ])
        if (resList.result) {
          this.dataTable =
            resList.data.list?.map((el) => {
              return {
                ...el,
                checked: this.idsSelected.includes(el.id)
              }
            }) || []
          this.selectAll = false
          this.pagination.total = resList.total
        }
        if (resCount.result) {
          this.totals = resCount.data
            .filter((item) => item.status)
            .sort((a, b) => a.status.localeCompare(b.status))
            .reduce((acc, item) => {
              const status = acc.find((s) => s.status === item.status)
              if (status) {
                status.count += item.count
              } else {
                const statusObj = this.listStatus.find(
                  (list) => list.id == item.status
                )
                acc.push({
                  status: statusObj.text,
                  status_class: statusObj.class,
                  count: item.count
                })
              }
              return acc
            }, [])
          this.totalCount = this.totals
            .filter((item) => item.status)
            .reduce((sum, item) => sum + item.count, 0)
        }
      } catch (e) {
        showMess(
          this,
          'Error',
          e.message,
          'danger',
          'b-toaster-top-right',
          5 * 60 * 60
        )
      } finally {
        this.isLoading = false
      }
    },
    async getDataV2(conditionsMap = {}) {
      const searchQuery = {
        limit: this.pagination.limit,
        page: this.pagination.page,
        ...conditionsMap,
        sort: {
          direction: this.pagination.sortType,
          properties: [this.pagination.sortField]
        }
      }
      try {
        this.isLoading = true
        const resList = await List(searchQuery)

        if (resList.result) {
          this.dataTable =
            resList.data.list?.map((el) => {
              return {
                ...el,
                checked: this.idsSelected.includes(el.id)
              }
            }) || []
          this.pagination.total = resList.data.count ?? 0

          const resCount = [
            {
              status: 'ACTIVE',
              count: resList.data.countActive ?? 0
            },
            {
              status: 'PENDING_CONFIRM_APPROVAL',
              count: resList.data.countPendingConfirmApproval ?? 0
            },
            {
              status: 'UNDEFINED',
              count: resList.data.countUndefined ?? 0
            },
            {
              status: 'SUSPENDED',
              count: resList.data.countSuspended ?? 0
            }
          ]

          this.totals = resCount
            .filter((item) => item.status)
            .sort((a, b) => a.status.localeCompare(b.status))
            .reduce((acc, item) => {
              const status = acc.find((s) => s.status === item.status)
              if (status) {
                status.count += item.count
              } else {
                const statusObj = this.listStatus.find(
                  (list) => list.id == item.status
                )
                acc.push({
                  status: statusObj.text,
                  status_class: statusObj.class,
                  count: item.count
                })
              }
              return acc
            }, [])
          this.totalCount = resList.data.count ?? 0
        }
      } catch (e) {
        showMess(
          this,
          'Error',
          e.message,
          'danger',
          'b-toaster-top-right',
          5 * 60 * 60
        )
      } finally {
        this.isLoading = false
      }
    },
    formatDate(date, format = 'HH:mm, DD/MM/YYYY') {
      if (!date) return
      return moment(date).format(format)
    },
    // async loadData(conditionsMap = {}) {
    //   try {
    //     this.isLoading = true;
    //     const searchQuery = {
    //       limit: this.pagination.limit,
    //       page: this.pagination.page,
    //       queryString: this.pagination.queryString,
    //       ...conditionsMap,
    //       sort: {
    //         direction: this.pagination.sortType,
    //         properties: [this.pagination.sortField],
    //       }
    //     };
    //     const res = await List(searchQuery);
    //     this.dataTable = res.data.map(el => {
    //       return {
    //         ...el,
    //         checked: false,
    //       }
    //     });
    //     this.pagination.total = res.total;
    //   } catch (e) {
    //     showMess(this, 'Error', e.message, 'danger', 'b-toaster-top-right', 5 * 60 * 60)
    //   } finally {
    //     this.isLoading = false;
    //   }
    // },

    // async getCount(conditionsMap = {}) {
    //   try {
    //     this.isLoading = true;
    //     const res = await GetCount({
    //       limit: this.pagination.limit,
    //       page: this.pagination.page,
    //       queryString: this.pagination.queryString,
    //       ...conditionsMap,
    //       sort: {
    //         direction: this.pagination.sortType,
    //         properties: [this.pagination.sortField],
    //       }
    //     });
    //     if (res.result) {
    //       // this.totals.suspend = res.data.find(obj => obj.status === 'SUSPENDED')?.count || 0
    //       // this.totals.active = res.data.find(obj => obj.status === 'ACTIVE')?.count || 0

    //       this.totals = res.data.filter(item => item.status)
    //         .sort((a, b) => a.status.localeCompare(b.status))
    //         .reduce((acc, item) => {
    //           const status = acc.find(s => s.status === item.status);
    //           if (status) {
    //             status.count += item.count;
    //           } else {
    //             const statusObj = this.listStatus.find(list => list.id == item.status)
    //             acc.push({ status: statusObj.text, status_class: statusObj.class, count: item.count });
    //           }
    //           return acc;
    //         }, []);
    //       this.totalCount = this.totals
    //         .filter(item => item.status)
    //         .reduce((sum, item) => sum + item.count, 0);
    //     }
    //   } catch (e) {
    //     showMess(this, 'Error', e.message, 'danger', 'b-toaster-top-right', 5 * 60 * 60)
    //   } finally {
    //     this.isLoading = false;
    //   }
    // },

    async submitForm(event) {
      event.preventDefault()
      this.pagination.page = 1
      // this.buildQuery()
      this.buildQueryV2()
    },
    // search Ngành nghề
    searchBusinessType(item) {
      this.filters.mainBusinessMcc = item.mainBusinessMcc
    },
    // search Loại hình doanh nghiệp
    searchOwnershipType(item) {
      this.filters.ownershipType = item.ownershipType
    },
    // page
    onChangePage(pageIndex) {
      this.pagination.page = pageIndex
      // this.buildQuery();
      this.buildQueryV2()
    },
    // checkbox
    // onAssignHandle() {
    //   const checkedIds = this.dataTable.reduce((arr, item) => {
    //     item.checked && arr.push(item.id);
    //     return arr;
    //   }, []);

    //   if (checkedIds.length > 0) {
    //     const addParams = {
    //       ids: checkedIds,
    //       level: 'MERCHANT_OWNER'
    //     };

    //     const random = Math.random()
    //       .toString(36)
    //       .substring(2, 15)
    //     localStorage.setItem(random, JSON.stringify(addParams));
    //     this.$router.push(`/customer-support/add-staff/${random}`);
    //   }
    // },
    // onAssignHandle() {
    //   const checkedIds = this.dataTable.reduce((arr, item) => {
    //     item.checked && arr.push(item.id);
    //     return arr;
    //   }, []);
    //   if (checkedIds.length > 0) {
    //     const gzipData = gzip.zip(checkedIds.join(','), {
    //       level: 9,
    //     });
    //     const encodedString = btoa(String.fromCharCode(...gzipData));
    //     this.$router.push({ path: `/customer-support/add-staff/MERCHANT_OWNER`, query: { ids: encodedString } });
    //   }
    // },
    onAssignHandle() {
      const checkedIds = this.idsSelected
      if (checkedIds.length > 0) {
        const gzipData = gzip.zip(checkedIds.join(','), {
          level: 9
        })
        const encodedString = btoa(String.fromCharCode(...gzipData))
        this.$router.push({
          path: `/customer-support/add-staff/MERCHANT_OWNER`,
          query: { ids: encodedString }
        })
      }
    },
    toggleSelectAll() {
      // this.dataTable.forEach(item => {
      //   item.checked = this.selectAll;
      // });
      const value = this.selectAll
      for (const item of this.dataTable) {
        item.checked = value
        const id = item.id
        const index = this.idsSelected.indexOf(id)
        index >= 0 && this.idsSelected.splice(index, 1)
        if (value) {
          !this.idsSelected.includes(id) && this.idsSelected.push(id)
        }
      }
      this.cleanSelectIfOver()
    },
    toggleSelectOne(item) {
      const id = item.id
      const index = this.idsSelected.indexOf(id)
      index >= 0 && this.idsSelected.splice(index, 1)
      if (item.checked) {
        !this.idsSelected.includes(id) && this.idsSelected.push(id)
      }
      this.selectAll = this.dataTable.every((item) => item.checked)
      this.cleanSelectIfOver()
    },
    onClearSelect() {
      this.idsSelected = []
      this.selectAll && (this.selectAll = false)
      this.dataTable.forEach((item) => {
        item.checked && (item.checked = false)
      })
    },
    cleanSelectIfOver() {
      this.idsSelected.length > maxtSelect &&
        (() => {
          this.idsSelected = this.idsSelected.slice(-maxtSelect)
        })()
    },
    // lấy vùng
    async getRegions() {
      const data = await StaffService.getRegions()
      if (data.data.length > 0) {
        this.dataConfigRegion = data.data.map((e) => {
          return {
            id: e.id,
            text: e.name
          }
        })
        this.dataConfigRegion.unshift({ id: '0', text: 'Tất cả' })
      }
    },
    // lấy tỉnh, tp
    async queryProvince(e) {
      try {
        this.businessProvinceCode = ''
        this.dataProvince = []
        const data = await StaffService.getProvinceRegion({ regionId: [e] })
        if (data.data.length > 0) {
          this.dataProvince = data.data.map((e) => {
            return {
              id: e.id,
              text: e.name
            }
          })
          this.dataProvince.unshift({ id: '0', text: 'Tất cả' })
        }
      } catch (error) {}
    },
    // lấy vùng mc
    async getMcRegions() {
      const data = await StaffService.getListRegions()
      if (data.data.length > 0) {
        this.dataConfigRegionMC = data.data.map((e) => {
          return {
            id: e.id,
            text: e.name,
            code: e.code
          }
        })
        this.dataConfigRegionMC.unshift({ id: '0', text: 'Tất cả' })
      }
    },
    // lấy tỉnh, tp mc
    async queryMcProvince(e) {
      try {
        this.filters.provinceCode = ''
        this.filters.districtCode = ''
        this.dataDistrict = []
        this.dataProvinceMC = []
        const data = await StaffService.getProvinceRegion({ regionId: [e] })
        if (data.data.length > 0) {
          this.dataProvinceMC = data.data.map((e) => {
            return {
              id: e.code,
              text: e.name
            }
          })
          this.dataProvinceMC.unshift({ id: '0', text: 'Tất cả' })
        }
      } catch (error) {}
    },
    // lấy quận mc
    async getMcDistrict(event) {
      this.dataDistrict = level3LocationDetails
        .filter((item) => item.code.includes(event))
        .sort((a, b) => a.code.localeCompare(b.code))
        .map((e) => {
          return {
            id: e.code,
            text: e.name
          }
        })
      this.dataDistrict.unshift({ id: '0', text: 'Tất cả' })
    },
    // Lấy danh sách nhân viên
    async getListStaffBySuperior() {
      try {
        const data = await StaffService.getStaffByIdSuperior({
          userId: this.userId
        })
        if (data.data.length > 0) {
          this.listUser = data.data.map((e) => {
            return {
              id: e.userId,
              text: `${e.name} - ${e.userName}`
            }
          })
          this.listUser.unshift({ id: '0', text: 'Tất cả' })
        }
      } catch (error) {
        console.log(error)
      }
    },
    // Lấy quản lý
    async getManager() {
      try {
        const data = await StaffService.superiors()
        if (data.success) {
          this.dataManager = data.data.map((e) => {
            return {
              id: e.id,
              text: `${e.name} - ${e.userName}`
            }
          })
          this.dataManager.unshift({ id: '0', text: 'Tất cả' })
        }
      } catch (error) {
        console.log(error)
      }
    },
    // lấy ngành hàng và dịch vụ
    configSystem() {
      return CommonService.getConfigSystem()
        .then((data) => {
          if (data.success) {
            this.ownershipType = data.data.ownershipType.map((item) => {
              return {
                id: item.code,
                text: item.name
              }
            })
            this.ownershipType.unshift({ id: '0', text: 'Tất cả' })
            this.dataConfigService = data.data.services.map((e) => {
              return {
                id: e.code,
                text: e.name
              }
            })
            this.dataConfigService.unshift({ id: '0', text: 'Tất cả' })
            this.getListService()
            this.dataConfigMcc = data.data.businessFields.map((e) => {
              return {
                id: e.code,
                text: e.name
              }
            })
            this.dataConfigMcc.unshift({ id: '0', text: 'Tất cả' })
          }
        })
        .catch((error) => console.error(error))
    },
    async getListService() {
      try {
        const response = await SalesManagerService.getGroupService({})
        if (response.code === 1000) {
          this.dataGroupService = response.data.groupService
          const data = this.dataGroupService.filter((e) => e.service === 'SELL')
          if (data[0].detail.length > 0) {
            this.dataConfigService = data[0].detail.map((e) => {
              return {
                id: e.code,
                text: this.serviceTypes(e.name)
              }
            })
          }
          // ListState
          this.listStateSearch = [
            { id: '0', text: 'Tất cả' },
            ...this.listState
          ]
        }
      } catch (error) {
        console.log(error)
      }
    },
    serviceTypes(itemm) {
      const listServiceTypes = Config.listServiceTypes
      return listServiceTypes[itemm] ? listServiceTypes[itemm] : itemm
    }
  }
}
</script>
<style scoped>
.total_check {
  /* margin: 5px; */
  /* text-align: center; */
  display: flex;
  text-align: center;
}

.total_label {
  color: #8a9298;
  font-size: 14px;
}

.total_field {
  font-size: 20px;
}
</style>
<style>
.td_class {
  min-width: 150px;
  max-width: 200px;
}

.time_class {
  min-width: 100px;
  max-width: 150px;
}

.nowrap {
  white-space: nowrap;
}

.tooltip-class .tooltip-inner {
  background-color: rgb(253, 253, 253);
  color: #319db5;
  text-align: left;
  max-height: 150px;
  max-width: 200px;
  overflow-y: auto;
  border: 1px solid;
}

.b-table tbody tr {
  font-size: 12px;
  font-weight: 400;
  line-height: 14.06px;
  text-align: left;
}

.b-table thead tr {
  font-size: 13px;
  font-weight: 500;
  line-height: 15.23px;
  text-align: left;
}

.title_mo {
  font-size: 20px;
  font-weight: 400;
  line-height: 23.44px;
  text-align: left;
}

.list_total {
  font-size: 13px;
  font-weight: 400;
  line-height: 15.23px;
  text-align: left;
}

.search_css {
  font-size: 12px;
  font-weight: 400;
  line-height: 14.06px;
  text-align: left;
}
</style>
<style>
.address_class {
  min-width: 100px;
  max-width: 220px;
}

.owner_class {
  min-width: 120px;
  max-width: 220px;
}

.business_type_class {
  min-width: 100px;
  max-width: 180px;
}

.status_class {
  min-width: 100px;
  max-width: 120px;
}

.clean-select {
  &:hover {
    text-decoration: line-through;
  }
}
</style>
